export function appDomain(): string {
  const raw = (typeof __APP_DOMAIN__ !== 'undefined' ? __APP_DOMAIN__ : '').trim()
  return raw.replace(/^https?:\/\//i, '').split('/')[0].replace(/:\d+$/, '')
}

export function appOrigin(): string {
  const domain = appDomain()
  return domain ? `https://${domain}` : ''
}

export function appCodeHost(): string {
  const domain = appDomain()
  return domain ? `code.${domain}` : ''
}

export function appWsUrl(): string {
  const domain = appDomain()
  return domain ? `wss://ws.${domain}/connection/websocket` : ''
}

export function appStatusOrigin(): string {
  const domain = appDomain()
  return domain ? `https://status.${domain}` : ''
}

export function applyAppDomain(text: string): string {
  const domain = appDomain()
  if (!domain || !text.includes('chatcx.live')) return text
  return text.split('chatcx.live').join(domain)
}

export function isStatusHost(): boolean {
  const domain = appDomain().toLowerCase()
  return Boolean(domain) && typeof window !== 'undefined' && window.location.hostname.toLowerCase() === `status.${domain}`
}

export function siteHref(path: string): string {
  const domain = appDomain().toLowerCase()
  if (!domain || typeof window === 'undefined' || !path.startsWith('/') || path.startsWith('//')) return path
  const host = window.location.hostname.toLowerCase()
  const statusHost = isStatusHost()
  if (!statusHost && host !== domain && host !== `www.${domain}`) return path
  const pathname = path.split(/[?#]/)[0]
  if (pathname === '/status' || pathname === '/status/') return `${appStatusOrigin()}/${path.slice(pathname.length)}`
  return statusHost ? `${appOrigin()}${path}` : path
}
